import React from 'react';
import VoucherPage from './VoucherPage';

const DiskPage: React.FC = () => {
  return <VoucherPage category="disk" />;
};

export default DiskPage;
